import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PendingTimesheetReminderComponent } from './pending-timesheet-reminder.component';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';

@NgModule({
  declarations: [
    PendingTimesheetReminderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppCommonModule,
    ServiceProxyModule
  ],
  exports: [
    PendingTimesheetReminderComponent
  ]
})
export class PendingTimesheetReminderModule { }
